<template>
  <card-seplag titulo="Importar bases externas">
    <Loader
      :isVisible.sync="loaderTrue"
      :text="'Carregando'"
      v-if="loaderTrue"
    />
    <div class="p-grid p-fluid">
      <div class="p-col-12">
        <card-seplag>
          <Rotulo cols="12">
            <h3>Orientações para o procedimento de importação de dados:</h3>
          </Rotulo>
          <Rotulo cols="12">
            <h4>
              Seguir o padrão implicíto para a construção do documento base para
              a importação de dados, com os campos:
            </h4>
          </Rotulo>
          <Rotulo cols="12">
            <h4>
              | CPF | SERVIDOR | EMPRESA | NOME | E-MAIL | SEXO | DATA NASC |
              ESCOLARIDADE ATUAL | TELEFONE |
            </h4>
          </Rotulo>
          <div class="p-col-12 divPlanilhaExemplo">
            <Button
              style="max-width:20rem"
              label="Download Exemplo da Planilha"
              icon="pi pi-cloud-download"
              @click="downloadPlanilhaExemplo"
            />
          </div>
          <!-- <pre>{{json_array}}</pre> -->
          <!-- {{teste}} -->
        </card-seplag>

        <div class="p-col-12">
          <div
            class="p-grid p-fluid "
            style="align-items: flex-end;justify-content: space-between;"
          >
            <Rotulo cols="12 3" nome="Buscar Arquivo">
              <FileUpload
                :customUpload="true"
                mode="basic"
                chooseLabel="Selecionar"
                invalidFileSizeMessage="Tamanho Máximo do Arquivo Não Permitido. Tamanho Máximo de {1}."
                invalidFileTypeMessage="Tipo de Arquivo Não Permitido. Tipos Permitidos são Images ou PDF"
                accept=".xls, .xlsx, .csv"
                @select="onUploadBasesExternas"
                ref="fileupload"
              />
            </Rotulo>

            <Rotulo cols="12 3" nome="Planilha" v-if="planilhas.length > 0">
              <Dropdown
                v-model="planilhaSelecionada"
                :options="planilhas"
                :disabled="planilhas.length == 1"
                placeholder="Selecione a planilha"
              />
            </Rotulo>

            <Rotulo cols="12 3">
              <Button
                label="Importar Dados"
                icon="pi pi-plus"
                class="p-button-success"
                @click="enviarDados()"
              />
            </Rotulo>
            <Rotulo cols="12 3">
              <Button
                label="Limpar Dados"
                icon="pi pi-arrow-left"
                class="p-button-danger"
                @click="limparDados()"
              />
            </Rotulo>
          </div>
          <div class="p-col-12">
            <Rotulo nome="Dados a serem Importados: " cols="12 ">
              <table-seplag
                :dados.sync="json_array"
                :exibirCabecalho="false"
                :campos="colunas"
                :totalRegistro="json_array.length"
                :isExisteAcoesCustom="true"
                :paginacao="true"
              >
                <template #acoes="slotProps">
                  <Button
                    v-if="
                      slotProps.data.flagDadoImportado != null &&
                        slotProps.data.flagDadoImportado != undefined
                    "
                    :icon="iconName(slotProps.data)"
                    :class="className(slotProps.data)"
                    :disabled="slotProps.data.flagDadoImportado == 'S'"
                    @click="() => openModalMotivoRejeicao(slotProps.data)"
                  />

                  <i
                    v-else
                    class="pi pi-send"
                    style="font-size: 1.5rem; color:#005494;cursor:default"
                  >
                  </i>
                </template>
              </table-seplag>
            </Rotulo>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      header="Motivo da rejeição"
      :visible.sync="modalMotivoRejeicao"
      :modal="true"
      :style="{ width: '30vw' }"
    >
      <p class="m-0">{{ textoMensagem }}</p>

      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="fecharModalMotivoRejeicao"
          class="p-button-text"
        />
      </template>
    </Dialog>
  </card-seplag>
</template>
<script>
import XLSX from 'xlsx';
import CardSeplag from '../../template/CardSeplag.vue';
import TableSeplag from '../../template/TableSeplag.vue';
import Rotulo from '../../template/RotuloSeplag.vue';
import { baseApiUrl, printToast } from '../../config/global';
import Loader from '@/paginas/Loader.vue';
// import { PassThrough } from "stream";

let andeparaDados = new Map();
andeparaDados.set('dataNasc', 'dataNascimento');
andeparaDados.set('escolaridadeAtual', 'escolaridade');

export default {
  components: { CardSeplag, TableSeplag, Rotulo, Loader },
  name: 'uploadBaseExterna',
  data: function() {
    return {
      textoMensagem: '',
      loaderTrue: false,
      modalMotivoRejeicao: false,
      planilhas: [],
      planilhaSelecionada: '',
      workbook: {},
      json_array: [],
      colunas: [
        { nome: 'cpf', titulo: 'CPF', tamanho: '9.rem' },
        { nome: 'servidor', titulo: 'Servidor', tamanho: '5.rem' },
        { nome: 'empresa', titulo: 'Empresa' },
        { nome: 'nome', titulo: 'Nome' },
        { nome: 'email', titulo: 'E-mail' },
        {
          nome: 'sexo',
          titulo: 'Sexo',
          tamanho: '4.rem',
          alinhamento: 'center',
        },
        { nome: 'dataNascimento', titulo: 'Data nasc' },
        {
          nome: 'escolaridade',
          titulo: 'Escolaridade',
          tamanho: '14.rem',
        },
        { nome: 'telefone', titulo: 'Telefone' },
      ],
      file: null,
      telefone: { telefone: '99999999999' },
      numrTelefonePessoal: { numrTelefonePessoal: '99999999999' },
      teste: [],
    };
  },
  updated() {
    if (this.file) {
      setTimeout(this.load(this.file), 40);
    }
  },
  methods: {
    async downloadPlanilhaExemplo() {
      let response = await this.$http.get(
        `${baseApiUrl}/escolaridades/recadastramento/all`
      );
      let listaEscolaridade = response.data;

      let planilha1 = [
        {
          cpf: '99999999999',
          servidor: 'S',
          empresa: 'TESTE',
          nome: 'TESTE',
          email: 'TESTE@teste.com',
          sexo: 'M',
          dataNascimento: '99/99/9999',
          escolaridade: listaEscolaridade[0].nomeEscolaridade,
          Telefone: '99999999999',
        },
      ];

      let planilha2 = listaEscolaridade.map((item) => {
        return { nomeEscolaridade: item.nomeEscolaridade };
      });

      const worksheet1 = XLSX.utils.json_to_sheet(planilha1);
      const worksheet2 = XLSX.utils.json_to_sheet(planilha2);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet1, 'Dados');
      XLSX.utils.book_append_sheet(workbook, worksheet2, 'Escolaridades');

      XLSX.utils.sheet_add_aoa(
        worksheet1,
        [this.colunas.map((item) => item.titulo)],
        { origin: 'A1' }
      );
      XLSX.utils.sheet_add_aoa(worksheet2, [['Escolaridades Aceitas']], {
        origin: 'A1',
      });

      const max_width1 = 20;
      const max_width2 =
        planilha2.reduce((w, r) => Math.max(w, r.nomeEscolaridade.length), 10) +
        4;

      worksheet1['!cols'] = this.colunas.map((item) => ({ wch: max_width1 }));
      worksheet2['!cols'] = [{ wch: max_width2 }];

      XLSX.writeFile(workbook, 'PlanilhaExemplo.xlsx', { bookType: 'xlsx' });
    },
    async tratarDados() {
      let worksheet = this.workbook.Sheets[this.planilhaSelecionada];

      this.json_array = XLSX.utils.sheet_to_json(worksheet);

      this.json_array = this.json_array.map((item) => {
        let keys = Object.keys(item);
        let dados = {};

        keys.forEach((key) => {
          let keyTratado = key
            .replaceAll('-', '')
            .toLowerCase()
            .trim();

          let valorDoCampo = item[key];

          if (key == 'CPF') {
            let cpfStr = valorDoCampo.toString();
            cpfStr = cpfStr.replaceAll('.', '').replaceAll('-', '');
            valorDoCampo = valorDoCampo.toString().padStart(11, '0');
          }

          let isDate = valorDoCampo instanceof Date;

          let keyNormalizado = this.camelize(keyTratado);
          let keyDosDados = andeparaDados.has(keyNormalizado)
            ? andeparaDados.get(keyNormalizado)
            : keyNormalizado;

          if (isDate) {
            dados = {
              ...dados,
              [keyDosDados]: valorDoCampo.toLocaleDateString('pt-BR'),
            };
          } else {
            dados = {
              ...dados,
              [keyDosDados]:valorDoCampo
            };
          }
        });

        return dados;
      });
      
    },
    load(parm) {
      const { files } = parm;
      let self = this;

      var reader = new FileReader();

      reader.onload = function(e) {
        var data = new Uint8Array(e.target.result);

        self.workbook = XLSX.read(data, {
          type: 'array',
          cellDates: 'd',
          dateNF: 'FMT 14',
        });

        let planilhasDisponivel = self.workbook.Workbook.Sheets.filter(item => item.Hidden == 0).map(sheet => sheet.name)

        self.planilhas = planilhasDisponivel
        self.file = null;
        self.$refs.fileupload.files = [];

        if (planilhasDisponivel > 1) {
          self.loaderTrue = false;
          return;
        }

        self.planilhaSelecionada = planilhasDisponivel[0];
        self.loaderTrue = false;
      };

      reader.readAsArrayBuffer(files[0]);
    },
    onUploadBasesExternas(parm) {
      this.loaderTrue = true;
      this.file = parm;
    
    },
    camelize(str) {
      return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '');
    },
    enviarDados() {
      this.$http
        .post(
          `${baseApiUrl}/bases-externas/importar`,
          JSON.stringify(this.json_array)
        ).then(() => {
          this.$toast.add({ severity: 'success', summary: 'Dados cadastrados com sucesso', life: 5000 })
        });
    },
    fecharModalMotivoRejeicao() {
      this.modalMotivoRejeicao = false;
    },
    openModalMotivoRejeicao(rawData) {
      this.textoMensagem = rawData.msgErro;
      this.modalMotivoRejeicao = true;
    },
    iconName(data) {
      if (data.flagDadoImportado == 'N') {
        return 'pi pi-info';
      }
      return 'pi pi-check';
    },
    className(data) {
      if (data.flagDadoImportado == 'N') {
        return 'p-button-danger';
      }
      return 'p-button-success';
    },
    listarOrgaos() {
      this.$http.get(`${baseApiUrl}/orgaos`).then((res) => {
        res.data.filter((item) => {
          if (res.data.length > 0) {
            this.teste.push(item.descOrgao);
          }
        });
      });
    },
    limparDados() {
      this.json_array = [];
      this.planilhas = 0;
      this.planilhaSelecionada = '';
    },
  },
  watch: {
    planilhaSelecionada(novo, antigo) {
      this.tratarDados();
    },
  },
  mounted() {
    this.listarOrgaos();
  },
};
</script>
<style scoped>
.divPlanilhaExemplo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divPlanilhaExemplo button {
  max-width: 20rem;
}

.editCell {
  color: blue;
  text-align: center;
}

h3 {
  text-align: center;
}

h4 {
  text-align: center;
}
</style>
